import styled from 'styled-components';

export const ArticleWrapper = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    width: '80%',
    alignItems: 'center',
    textAlign: 'center',
    margin: '80px auto',
    gap: '40px', // This adds both row and column gaps
    // Or use specific gaps:
    // rowGap: '40px',
    // columnGap: '20px'
});